export const TL = (n) => {
  const v = Number(n || 0);
  return new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(v);
};

export const NUM = (n) =>
  new Intl.NumberFormat("tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(n || 0));

export const formatDate = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return new Intl.DateTimeFormat("tr-TR", {
      day: "2-digit", month: "2-digit", year: "numeric"
    }).format(d);
  } catch { return iso; }
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const CARI_TYPE_LABEL = {
  musteri: "Müşteri",
  acente: "Acente",
  tedarikci: "Tedarikçi",
};

export const ACCOUNT_TYPE_LABEL = {
  kasa: "Kasa",
  banka: "Banka",
};

export const TXN_KIND_LABEL = {
  gelir: "Gelir",
  gider: "Gider",
  tahsilat: "Tahsilat",
  odeme: "Ödeme",
  transfer_in: "Transfer Giriş",
  transfer_out: "Transfer Çıkış",
};
